import {
  ColorTokenData,
  DocumentationItemConfigurationV1,
  DocumentationItemHeaderAlignment,
  DocumentationItemHeaderImageScaleType,
} from "@supernova-studio/model";
import { DTODocumentationItemConfigurationV1 } from "../../dto";

export const getDtoDefaultItemConfigurationV1 = () =>
  ({
    showSidebar: true,
    isHidden: false,
    isPrivate: false,
    header: {
      alignment: DocumentationItemHeaderAlignment.Left,
      backgroundImageScaleType: DocumentationItemHeaderImageScaleType.AspectFill,
      description: "",
      showBackgroundOverlay: false,
      showCoverText: true,
    },
  } as const);

export function documentationItemConfigurationToDTOV1(
  config: DocumentationItemConfigurationV1 | undefined
): DTODocumentationItemConfigurationV1 {
  const dtoDefaultItemConfigurationV1 = getDtoDefaultItemConfigurationV1();
  if (!config) return dtoDefaultItemConfigurationV1;

  const { backgroundColor, foregroundColor, ...headerRest } = config.header;

  return {
    showSidebar: config.showSidebar,
    isHidden: config.isHidden ?? dtoDefaultItemConfigurationV1.isHidden,
    isPrivate: config.isPrivate ?? dtoDefaultItemConfigurationV1.isPrivate,
    header: {
      ...headerRest,
      backgroundColor: colorToDTOV1(backgroundColor ?? undefined),
      foregroundColor: colorToDTOV1(foregroundColor ?? undefined),
    },
  };
}

function colorToDTOV1(color: ColorTokenData | undefined) {
  if (!color) return undefined;
  if (color.aliasTo) return { aliasTo: color.aliasTo };
  if (!color.value) return undefined;

  if (typeof color.value === "string") return { value: color.value };
  if (typeof color.value.color === "string") return { value: color.value.color };

  return undefined;
}
